<template>
    <v-container
        id="ticket-map"
    >
        <!-- Mobile Company Name Header -->
        <v-row
            v-if="this.$vuetify.breakpoint.xs"
            dense
        >
            <v-col>
                <div class="mobile-company-header pa-3">
                    {{ companyName }}
                </div>
                <v-divider class="mt-2" />
            </v-col>
        </v-row>
        <v-row
            :no-gutters="this.$vuetify.breakpoint.xs"
            dense
        >
            <!-- Page Header -->
            <v-col
                :class="this.$vuetify.breakpoint.xs ? 'px-3' : ''"
            >
                <MapDesktopHeaderToolbar
                    v-if="this.$vuetify.breakpoint.smAndUp"
                />
                <MapMobileHeaderToolbar
                    v-else
                />
            </v-col>
        </v-row>
        <v-row
            dense
        >
            <v-col
                :cols="this.$vuetify.breakpoint.xs ? '12' : '3'"
            >
                <v-select
                    v-model="source"
                    :items="tabList"
                    item-text="label"
                    item-value="tabId"
                    label="Source"
                    hide-details="true"
                    outlined
                    dense
                    @change="updateSource"
                />
            </v-col>
            <v-col
                :cols="this.$vuetify.breakpoint.xs ? '12' : '3'"
                class="hidden-xs-only"
            >
                <v-select
                    v-model="state"
                    :items="states"
                    item-text="state"
                    item-value="state"
                    label="State"
                    hide-details="true"
                    outlined
                    dense
                    :disabled="isDisabled"
                    @change="updateCounty"
                />
            </v-col>
            <v-col
                :cols="this.$vuetify.breakpoint.xs ? '12' : '3'"
                class="hidden-xs-only"
            >
                <v-select
                    v-model="county"
                    :items="counties"
                    item-text="displayText"
                    item-value="name"
                    label="County"
                    hide-details="true"
                    outlined
                    dense
                />
            </v-col>
        </v-row>
        <v-row dense>
            <v-col>
                <MapViewer
                    :county="county"
                    :source="source"
                    :state="state"
                />
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import webtmsBackend from '@/services/webtmsBackend';
import MapViewer from './MapViewer.vue';
import MapMobileHeaderToolbar from './MapMobileHeaderToolbar.vue';
import MapDesktopHeaderToolbar from './MapDesktopHeaderToolbar.vue';
import { getUserOption } from '../../utils/options';
import { defaultOpenTicketsTabOptions,defaultTicketFields,defaultTicketFilters } from '../../services/ticketDataHelpers';

export default {
    components: {
        MapViewer,
        MapMobileHeaderToolbar,
        MapDesktopHeaderToolbar
    },
    data: () => ({
        state : '',
        county : '*',
        source : 'open-tickets',
        ticketTabs:[],
        tickets: [],
        page:'1',
    }),
    computed: {
        isDisabled() {
            return this.states.length === 1;
        },
        activeTab() {
            return this.$store.getters.activeTab;
        },
        getActiveTabObject(){
            const JSONTAB = 'JSON:TAB:' + this.activeTab.tabId;
            const tabJson = getUserOption(JSONTAB);
            return tabJson ? JSON.parse(tabJson) : defaultOpenTicketsTabOptions;
        },
        companyName() {
            return this.$store.getters.company.company;
        },
        states() {
            let data = this.$store.getters.counties;
            // Find all unique states
            let states = [...new Set(data.map(item => item[2]))];
            return states;
        },
        counties() {
            let data = this.$store.getters.counties;
            let counties = [];
            counties.push({state:'', fips:'', name: '*', displayText:'Show ALL'});
            data.forEach(county => {
                let name = county[3];
                let fips = county[1];
                let state = county[2];

                if (counties.indexOf(name) === -1) {
                    if(state === this.state) {
                        counties.push({state:state, fips:fips, name:name, displayText:fips +' - '+ name + ' County, '+ state });
                    }
                }
            });
            return counties;
        },
        tabList: function(){
            let list = [];
            list.push({tabId: 'open-tickets', label: 'Tickets'});
            list.push({tabId: 'open-tickets-selected ', label: 'Tickets (Selected)'});

            this.ticketTabs.forEach(function(tab){
                list.push({
                    tabId: tab.tabId,
                    label: tab.label,
                });
                list.push({
                    tabId: `${tab.tabId}-selected`,
                    label: `${tab.label} (Selected)`,
                });
            });

            list.push({tabId: 'tickets-clipboard', label: 'Clipboard'});
            return list;
        },
    },
    mounted() {
        // Set the default state to the company state
        this.state = this.$store.getters.companyCenters[0].state;
        // this.county = this.getDefaultCountyName();
        this.ticketTabs = this.getTicketTabs();
        this.getTickets();
    },

    methods: {
        getTicketTabs: function() {
            let overviewOpenTickets = this.$store.getters.overviewOpenTickets;
            return this.$store.getters.userOptions.filter((item) => {
                let openTickets = item.option.search('JSON:TAB:open-tickets--');
                return openTickets == 0;
            }).map((item) => {
                let ticketJSON = JSON.parse(item.value);
                if(ticketJSON) {
                    if(ticketJSON.config.filters.TR_stage === '*') {
                        ticketJSON.count = overviewOpenTickets.overviewStage['OPEN'];
                    }else if(ticketJSON.config.filters.TR_stage === 'ALL') {
                        ticketJSON.count = overviewOpenTickets.overviewStage['AL'];
                    } else {
                        ticketJSON.count = overviewOpenTickets.overviewStage[ticketJSON.config.filters.TR_stage];
                    }
                }
                return ticketJSON;
            }).sort((a, b) => Number(a.tabMoniker) - Number(b.tabMoniker));
        },
        checkCounty(fips) {
            return this.county === fips;
        },
        updateSource() {
            this.getTickets();

        },
        async getTickets() {
            try {
                let results = [];
                this.tickets = [];

                if(this.source.indexOf('selected') > -1 ) {
                    // Get the selected tickets from the store
                    let selectedTickets = this.$store.getters.tabSelectedItems;
                    let selectedTab = this.source.replace('-selected', '').trim();
                    results = selectedTickets[selectedTab];
                } else if(this.source.indexOf('clipboard') > -1){
                    // Get the clipboard tickets from the store
                    results = this.$store.getters.userClipboard;
                } else {
                    // Get all the tickets from the store
                    let ticketResponse = [];
                    const JSONTAB = 'JSON:TAB:' + this.activeTab.tabId;
                    let options = [];
                    options.push([JSONTAB, JSON.stringify(this.getActiveTabObject)]);
                    let optionValue = options[0][1];
                    optionValue = JSON.parse(optionValue);
                    const page = optionValue?.config?.page ? optionValue.config.page : this.page;
                    const itemsPerPage = optionValue?.config?.pageSize ? optionValue.config.pageSize : 25;
                    const fields = optionValue?.config?.fields ? optionValue.config.fields : defaultTicketFields;
                    const orderBy = optionValue?.config?.orderBy ? optionValue.config.orderBy : this.orderBy;                   
                    // Passing in orderByDefault as the orderBy parameter to support server side sorting
                    const filters = optionValue?.config?.filters ? optionValue.config.filters : defaultTicketFilters;
                    ticketResponse = await webtmsBackend.getTickets(page, itemsPerPage, fields, orderBy, filters);
                    if(ticketResponse.data) {
                        // All the tickets
                        results = ticketResponse.data;
                    }
                }
                if(results){
                    // filter out results fields don't need
                    results.forEach(result => {
                        this.tickets.push({
                            tid: result.tid,
                            ticket: result.ticket,
                            revision: result.revision,
                            member_code: result.TR_member_code,
                            priority: result.priority,
                            type: result.type,
                            county: result.county,
                            place: result.place,
                            geo_lat: result.TS_geo_lat,
                            geo_long:result.TS_geo_long,
                            geo_height:result.TS_geo_height,
                        });
                    });
                }
                this.$store.dispatch('setTicketMapTickets', this.tickets);
            } catch(error) {
                console.error('getTickets error ', error);
            }
        },
        getDefaultCountyName() {
            let defaultCountyName = null;
            for(let i = 0; i < this.counties.length; i++) {
                if(this.counties[i].state === this.state) {
                    defaultCountyName = this.counties[i].name;
                    break;
                }
            }
            return defaultCountyName;
        },
        updateCounty() {
            this.county = this.getDefaultCountyName();
        },
    },
};

</script>
<style scoped>

</style>